import { render, staticRenderFns } from "./Page-Contract.vue?vue&type=template&id=c60e613c&"
import script from "./Page-Contract.vue?vue&type=script&lang=js&"
export * from "./Page-Contract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports